import {
    createFetchProductApiHandler
} from 'PyzShopUi/scripts/product-detail-page/includes/variant-helper/selectFilter';
import MiddlewareEventBus from 'PyzShopUi/scripts/react/common/lib/MiddlewareEventBus';
import { MediaCenterEvent } from 'PyzShopUi/scripts/react/common/events/mediaCenterEvent';
import IReactEvent from 'PyzShopUi/scripts/interfaces/article-list/IReactEvent';
import EventBus from 'PyzShopUi/scripts/utils/eventBus';
import FormUtils from 'PyzShopUi/scripts/utils/formUtils';
import { BikeSelectEvent } from 'PyzShopUi/scripts/react/common/events/bikeSelectEvent';
import ProductVariantDataHandler from 'PyzShopUi/scripts/product-detail-page/includes/productVariantData';
import { addFilterBikeParameter } from 'PyzShopUi/scripts/product-detail-page/includes/productDetailPageUrlParamHelper';

export default class MyBikeRadioButtonWidget {
    public static init = (articleMainInfoElement: HTMLElement, initProductInfoFunction: () => void): void => {
        const myBikeListElement: HTMLElement = articleMainInfoElement.querySelector('.js-my-bike-list');

        if (!myBikeListElement) {
            return;
        }

        const myBikeRadioButtons: NodeListOf<HTMLInputElement> = myBikeListElement.querySelectorAll('input[type="radio"]');

        if (!myBikeRadioButtons.length) {
            return;
        }

        const apiUrl = myBikeListElement.dataset.apiUrl;
        const selectHandler = createFetchProductApiHandler(apiUrl);

        const eventBus = EventBus.getInstance();
        myBikeRadioButtons.forEach((radio: HTMLInputElement): void => {
            const productsJson: string = radio.dataset?.products;
            const products = JSON.parse(productsJson);
            const concreteId = products?.[0]?.product_concrete_id ? parseInt(products?.[0]?.product_concrete_id, 10) : null;

            if (radio.checked) {
                MyBikeRadioButtonWidget.selectBike(radio);
                initProductInfoFunction();
                MyBikeRadioButtonWidget.publishMediaCenterRender(concreteId);
            }

            radio.addEventListener('change', () => {
                MyBikeRadioButtonWidget.selectBike(radio);
                selectHandler(concreteId);
                MyBikeRadioButtonWidget.publishMediaCenterRender(concreteId);
            });
        });

        eventBus.subscribe('MyBikeRadioButtonHandler:deselect', () => {
            myBikeRadioButtons.forEach((myBikeRadioButton) => FormUtils.uncheckRadioButton(myBikeRadioButton.parentElement, eventBus));
        });
    };

    private static selectBike(radio: HTMLInputElement) {
        const productVariantData = ProductVariantDataHandler.init();
        const productsJson: string = radio.dataset?.products;
        const products = JSON.parse(productsJson);
        const bikeExternalId: string = radio.dataset?.bikeExternalId;
        const bikeVariantDropDownSelector = '.bike-variant-dropdown[data-type="my-bike"]';

        if (bikeExternalId) {
            addFilterBikeParameter(bikeExternalId);
        }

        if (products?.length > 1) {
            const concreteName = (product) => productVariantData[product.product_concrete_id.toString()]?.fullName;
            const bikeVariantDropDown: HTMLElement = document.querySelector(bikeVariantDropDownSelector);
            const activeConcreteId: string = bikeVariantDropDown.dataset.concreteId;

            MiddlewareEventBus.getInstance().publish({
                type: BikeSelectEvent.SELECT_MY_BIKE,
                payload: {
                    options: products.map((product) => ({
                        value: product.product_concrete_id.toString(),
                        label: product.bike_association ? `${concreteName(product)} [${product.bike_association}]` : concreteName(product),
                        selected: product.product_concrete_id.toString() === activeConcreteId,
                    })),
                    bikeCode: bikeExternalId,
                    domEntryElement: bikeVariantDropDown,
                },
            });
        } else {
            MiddlewareEventBus.getInstance().publish({
                type: BikeSelectEvent.SELECT_MY_BIKE,
                payload: {
                    options: null,
                    bikeCode: bikeExternalId,
                    domEntryElement: document.querySelector(bikeVariantDropDownSelector),
                },
            });
        }
    }

    private static publishMediaCenterRender(concreteId: number) {
        const filterSlidesFunction = (swiperSlide: HTMLElement) =>
            concreteId === parseInt(swiperSlide.dataset.idConcrete, 10);
        const mediaCenterRenderFilteredSlidesEvent: IReactEvent<any> = {
            type: MediaCenterEvent.RENDER_FILTERED_SLIDES,
            payload: filterSlidesFunction
        };

        MiddlewareEventBus.getInstance().publish(mediaCenterRenderFilteredSlidesEvent);
    }
}
